import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DatePicker, DateTimePicker } from '@material-ui/pickers';
import { DateTime } from 'luxon';

// stuff for dialog - move if separating
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import CloseIcon from '@material-ui/icons/Close';

import PaginatedTable from 'app/components/tables/PaginatedTable';

import useApp from 'app/context/useApp';
import useApi from 'app/context/useApi';

import NewInvitationDialog from 'app/components/event/NewInvitationDialog';
import BatchPaymentDialog from 'app/components/accounting/payments/BatchPaymentDialog';
import Loading from 'app/components/loaders/Loading';
import { Typography } from '@material-ui/core';

const useFilterStyles = makeStyles(theme => ({
    subSection: {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.grey[200]
    },
    subSectionLoading: {
        textAlign: 'center',
        padding: theme.spacing(3),
        backgroundColor: theme.palette.grey[200]
    },
    dialogSpacing: {
        padding: theme.spacing(1)
    },
    noSpacing: {
        padding: 0
    },
    noMarginLeft: {
        marginLeft: 0
    },
    empty: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    noContentPadding: {
        padding: 0
    }
}));

const dateRange = [
    'Before',
    'After',
    'Between',
    'Outside',
    'Year'
]

const operators = [
    'Greater Than',
    'Less Than',
    'Equal To',
    'Not Equal To'
]

const dualDates = [ "Between", "Outside" ];

const renderDateInput = props => (
    <TextField
        variant="outlined"
        fullWidth
        className={props.className}
        onClick={props.onClick}
        id={props.id}
        value={props.value}
        disabled={props.disabled}
        label={props.label}
        helperText={props.helperText}
        {...props.inputProps}
    />
);

const membershipStatuses = [
    {
        id: 1,
        title: 'Good'
    },
    {
        id: 2,
        title: 'Bad'
    }
];

const paymentStatus = ['Paid', 'Unpaid'];

const invitationTypes = [
    {
        value: 'App\\Models\\Group',
        label: 'Group Invitations'
    },
    {
        value: 'App\\Models\\User',
        label: 'User Invitations'
    }
];

const attendenceStatuses = ['Pending', 'Accepted', 'Maybe', 'Withdrawn', 'Declined','Pay Later'];

const InvitationFilterDialog = (props) => {

    const classes = useFilterStyles()

    const { open, onClose, onFilter, tickets } = props;

    const [ filters, setFilters ] = useState([]);
    const [ invitationType, setInvitationType ] = useState([]);
    const [ statusChecked, setStatusChecked ] = useState([]);
    const [ memberStatusChecked, setMemberStatusChecked ] = useState([]);
    const [ paymentStatusOption, setPaymentStatusOption ] = useState('Paid');
    const [ ticketTypesChecked, setTicketTypesChecked ] = useState([]);
    const [ createdAtDate, setCreatedAtDate ] = useState(DateTime.local().startOf('day'));
    const [ createdAtDate2, setCreatedAtDate2 ] = useState(DateTime.local().endOf('day'));
    const [ createdAtRange, setCreatedAtRange ] = useState("Before");

    const { app } = useApp();

    // Get Functions ------------------------------------------

    const getFilters = () => {
        const newFilters = app.user.application_state.invitations.filters;
        const activeFilters = [];

        if (newFilters.groups && newFilters.groups instanceof Array && newFilters.groups.length > 0) {
            setMemberStatusChecked(newFilters.groups);
            activeFilters.push('groups')
        }

        if (newFilters.levels && newFilters.levels instanceof Array && newFilters.levels.length > 0) {
            setStatusChecked(newFilters.levels)
            activeFilters.push('membership_levels')
        }

        setFilters(activeFilters);
    }

    useEffect(() => {
        getFilters();
    }, []);

    // Handlers ------------------------------------

    const handleFilter = filter => {
        const newFilters = [...filters];
        const i = newFilters.indexOf(filter)

        if (i > -1) {
            newFilters.splice(i, 1)
        } else {
            newFilters.push(filter)
        }

        setFilters(newFilters);
    }

    const handleInvitationType = value => {
        const newChecked = [...invitationType];
        const i = newChecked.indexOf(value)

        if (i > -1) {
            newChecked.splice(i, 1)
        } else {
            newChecked.push(value)
        }

        setInvitationType(newChecked);
    }

    const handleMemberStatus = id => {
        const newChecked = [...memberStatusChecked]
        const i = newChecked.indexOf(id)

        if (i > -1) {
            newChecked.splice(i, 1)
        } else {
            newChecked.push(id)
        }

        setMemberStatusChecked(newChecked);
    }

    const handleAttendenceStatus = value => {
        const newChecked = [...statusChecked];
        const i = newChecked.indexOf(value)

        if (i > -1) {
            newChecked.splice(i, 1)
        } else {
            newChecked.push(value)
        }

        setStatusChecked(newChecked);
    }

    const handleTicketTypes = id => {
        const newChecked = [...ticketTypesChecked]
        const i = newChecked.indexOf(id)

        if (i > -1) {
            newChecked.splice(i, 1)
        } else {
            newChecked.push(id)
        }

        setTicketTypesChecked(newChecked);
    }

    const handlePaymentStatus = (status) => {
        setPaymentStatusOption(status);
    }

    const handleClose = () => {
        onClose();
    }

    // Posters -----------------------------

    const postFilter = () => {

        const data = {}

        if (filters.indexOf('invitation_types') > -1 && invitationType.length > 0) {
            data.invitation_types = invitationType;
        }

        if (filters.indexOf('membership_status') > -1 && memberStatusChecked.length > 0) {
            data.membership_status = memberStatusChecked;
        }

        if (filters.indexOf('attendence_status') > -1 && statusChecked.length > 0) {
            data.attendence_status = statusChecked;
        }

        if (filters.indexOf('ticket_types') > -1 && ticketTypesChecked.length > 0) {
            data.ticket_types = ticketTypesChecked;
        }

        if (filters.indexOf('payment_status') > -1) {
            data.payment_status = paymentStatusOption;
        }

        if (filters.indexOf('created_at') > -1) {
            data.created_at = {
                date_range: createdAtRange,
                start_date: createdAtDate.toSeconds(),
                end_date: createdAtDate2.toSeconds()
            };
        }

        // console.log(data)

        onFilter(data);
        onClose();
    }

    const postClear = () => {
        setStatusChecked([]);
        setMemberStatusChecked([]);
        setTicketTypesChecked([]);
        setFilters([]);
        onFilter({});
        onClose();
    }

    return (
        <Dialog
            maxWidth="xs"
            open={open}
            onClose={handleClose}
            fullWidth
            aria-labelledby="filter-users"
            >
            <DialogTitle className={classes.dialogSpacing}>
                <Grid container alignItems="center" justify="space-between">
                    <Grid item>
                        <Button color="primary" onClick={postClear} variant="outlined">
                            Clear
                        </Button>
                    </Grid>
                    <Grid item>
                        Filters
                    </Grid>
                    <Grid item>
                        <Button color="primary" variant="contained" onClick={postFilter}>
                            Filter
                        </Button>
                    </Grid>
                </Grid>
            </DialogTitle>
            <Divider />
            <DialogContent className={classes.noContentPadding}>
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={filters.indexOf('invitation_types') > -1}
                            onChange={() => handleFilter('invitation_types')}
                            name="invitation_types"
                            color="primary"
                        />
                    }
                    label="Invitation Type"
                />
                <Divider />
                <Collapse in={filters.indexOf('invitation_types') > -1}>
                    <FormGroup className={classes.subSection}>
                        {invitationTypes.map(type => (
                            <FormControlLabel
                                className={classes.noMarginLeft}
                                key={type.value}
                                control={
                                    <Checkbox
                                        checked={(invitationType.indexOf(type.value) > -1)}
                                        onChange={()=>handleInvitationType(type.value)}
                                        name={type.label}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={type.label}
                            />
                        ))}
                    </FormGroup>
                </Collapse>
                {/*
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={filters.indexOf('membership_status') > -1}
                            onChange={() => handleFilter('membership_status')}
                            name="membership_status"
                            color="primary"
                        />
                    }
                    label="Membership Status"
                />
                <Divider />
                <Collapse in={filters.indexOf('membership_status') > -1}>
                    <FormGroup className={classes.subSection}>
                        {membershipStatuses.map(status => (
                            <FormControlLabel
                                className={classes.noMarginLeft}
                                key={status.id}
                                control={
                                    <Checkbox
                                        checked={(memberStatusChecked.indexOf(status.id) > -1)}
                                        onChange={()=>handleMemberStatus(status.id)}
                                        name={status.title}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={status.title}
                            />
                        ))}
                    </FormGroup>
                </Collapse>
                
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={filters.indexOf('payment_status') > -1}
                            onChange={() => handleFilter('payment_status')}
                            name="payment_status"
                            color="primary"
                        />
                    }
                    label="Payment Status"
                />
                <Divider />
                <Collapse in={filters.indexOf('payment_status') > -1}>
                    <FormGroup className={classes.subSection}>
                        {paymentStatus.map(status => (
                            <FormControlLabel
                                className={classes.noMarginLeft}
                                key={status}
                                control={
                                    <Checkbox
                                        checked={(paymentStatusOption === status)}
                                        onChange={()=>handlePaymentStatus(status)}
                                        name={status}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={status}
                            />
                        ))}
                    </FormGroup>
                </Collapse>
                */}
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={filters.indexOf('attendence_status') > -1}
                            onChange={() => handleFilter('attendence_status')}
                            name="attendence_status"
                            color="primary"
                        />
                    }
                    label="Attendence Status"
                />
                <Divider />
                <Collapse in={filters.indexOf('attendence_status') > -1}>
                    <FormGroup className={classes.subSection}>
                        {attendenceStatuses.map((status, i) => (
                            <FormControlLabel
                                className={classes.noMarginLeft}
                                key={i}
                                control={
                                    <Checkbox
                                        checked={(statusChecked.indexOf(status) > -1)}
                                        onChange={()=>handleAttendenceStatus(status)}
                                        name={status}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={status}
                            />
                        ))}
                    </FormGroup>
                </Collapse>
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={filters.indexOf('ticket_types') > -1}
                            onChange={() => handleFilter('ticket_types')}
                            name="ticket_types"
                            color="primary"
                            disabled={! tickets || tickets.length === 0}
                        />
                    }
                    label="Ticket Types"
                />
                <Divider />
                <Collapse in={filters.indexOf('ticket_types') > -1}>
                    <FormGroup className={classes.subSection}>
                        {tickets && tickets.length > 0 && tickets.map(ticket => (
                            <FormControlLabel
                                className={classes.noMarginLeft}
                                key={ticket.id}
                                control={
                                    <Checkbox
                                        checked={(ticketTypesChecked.indexOf(ticket.id) > -1)}
                                        onChange={()=>handleTicketTypes(ticket.id)}
                                        name={ticket.title}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={ticket.title}
                            />
                        ))}
                    </FormGroup>
                </Collapse>
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={filters.indexOf('created_at') > -1}
                            onChange={() => handleFilter('created_at')}
                            name="created-at"
                            color="primary"
                        />
                    }
                    label="Date of Invitation"
                />
                <Divider />
                <Collapse in={filters.indexOf('created_at') > -1}>
                    <div className={classes.subSection}>
                        <TextField
                            select
                            variant="outlined"
                            fullWidth
                            onChange={(e) => setCreatedAtRange(e.target.value)}
                            value={createdAtRange}
                            label="Date Range Type"
                            margin="normal"
                            >
                            {dateRange.map((range, index) => (
                                <MenuItem key={index} value={range}>
                                    {range}
                                </MenuItem>
                            ))}
                        </TextField>
                        {createdAtRange === 'Year' ? (
                            <DatePicker
                                disableFuture
                                openTo="year"
                                format="yyyy"
                                label="Select Year"
                                views={["year"]}
                                value={createdAtDate}
                                onChange={(value) => setCreatedAtDate(value)}
                                TextFieldComponent={renderDateInput}
                                margin="normal"
                            />
                        ) : (
                            <DateTimePicker
                                label={dualDates.includes(createdAtRange) ? "Choose Start Date" : "Choose Date"}
                                inputVariant="outlined"
                                value={createdAtDate}
                                onChange={(value) => setCreatedAtDate(value)}
                                variant="outlined"
                                TextFieldComponent={renderDateInput}
                                minutesStep={15}
                                margin="normal"
                            />
                        )}
                        <Collapse in={dualDates.includes(createdAtRange)}>
                            <DateTimePicker
                                label="Choose End Date"
                                inputVariant="outlined"
                                value={createdAtDate2}
                                onChange={(value) => setCreatedAtDate2(value)}
                                variant="outlined"
                                TextFieldComponent={renderDateInput}
                                minutesStep={15}
                                margin="normal"
                            />
                        </Collapse>
                    </div>
                </Collapse>
            </DialogContent>
        </Dialog>
    )
}

const useEmailStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    margin: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },
    button: {
        whiteSpace: 'nowrap'
    }
}));

const InvitationEmailDialog = (props) => {
    const { open, onSave, onClose, onClosed, ids, event } = props;

    const [ loading, setLoading ] = useState(false);
    const [ errors, setErrors ] = useState({});

    const classes = useEmailStyles();
    const api = useApi();

    // Entering Functions ------------------------------------------

    // Handler Functions ------------------------------------------

    // Poster functions ------------------------------------------

    const postRSVP = () => {

        setLoading(true);

        api.post(`/admin/event/${event.id}/email/rsvp`, {ids: ids})
            .then(() => onSave())
            .catch(() => setLoading(false));
    };

    const postQRCodes = () => {

        setLoading(true);

        api.post(`/admin/event/${event.id}/email/codes`, {ids: ids})
            .then(() => onSave())
            .catch(() => setLoading(false));
    };

    const postGuestForms = () => {

        setLoading(true);

        api.post(`/admin/event/${event.id}/email/forms`, {ids: ids})
            .then(() => onSave())
            .catch(() => setLoading(false));
    };

    // Error Handling -------------------------------------------

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    }

    // Exting Functions ----------------------------------------

    const clearState = () => {

    };

    const handleClosed = () => {
        clearState();
        setLoading(false);
        if (onClosed) onClosed();
    }

    return (
        <Dialog
            aria-labelledby="email-campaign-dialog-title"
            open={open}
            aria-describedby="email-campaign-dialogue-description"
            fullWidth
            maxWidth="sm"
            disableBackdropClick
            TransitionProps={{
                onExited: handleClosed,
            }}
            >
            <Loading isLoading={loading}/>
            <DialogTitle id="edit-date-dialog-title">
                Event Email Campaigns
                <IconButton aria-label="Cancel" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers id="edit-date-dialog-content">
                <Grid container justifyContent='space-between' spacing={3} wrap="nowrap">
                    <Grid item>
                        <Typography color="textSecondary">
                            Would you like to send RSVP emails to {ids > 0 ? 'the selected' : 'all'} guests? Only guests that have the status of <strong>PENDING</strong> will be asked to rsvp.
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button onClick={postRSVP} color="primary" disabled={loading} variant="outlined" className={classes.button}>
                            Send RSVP Emails
                        </Button>
                    </Grid>
                </Grid>
                <Divider className={classes.margin}/>
                <Grid container justifyContent='space-between' spacing={3} wrap="nowrap">
                    <Grid item>
                        <Typography color="textSecondary">
                            Would you like to send QR Code emails to {ids > 0 ? 'the selected' : 'all'} guests?
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button onClick={postQRCodes} color="primary" disabled={loading} variant="outlined" className={classes.button}>
                            Send QR Code Emails
                        </Button>
                    </Grid>
                </Grid>
                <Divider className={classes.margin}/>
                <Grid container justifyContent='space-between' spacing={3} wrap="nowrap">
                    <Grid item>
                        <Typography color="textSecondary">
                            Would you like to send Guest Form links to {ids > 0 ? 'the selected' : 'all'} guests?
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button onClick={postGuestForms} color="primary" disabled={loading} variant="outlined" className={classes.button}>
                            Send Guest Form Emails
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

const columns = [
    {
        id: 'created_at',
        align: 'left',
        disablePadding: false,
        label: 'Created At',
        type: 'date',
        format: 'ff'
    },
    {
        id: 'guest_name',
        align: 'left',
        disablePadding: true,
        label: 'Guest Name',
        type: 'link',
        link: '/admin/users/',
        link_id: 'guest_id'
    },
    {
        id: 'guest_first_name',
        align: 'left',
        disablePadding: true,
        label: 'Guest First',
        type: 'link',
        link: '/admin/users/',
        link_id: 'guest_id'
    },
    {
        id: 'guest_last_name',
        align: 'left',
        disablePadding: true,
        label: 'Guest Last',
        type: 'link',
        link: '/admin/users/',
        link_id: 'guest_id'
    },
    {
        id: 'guest_dates',
        align: 'left',
        disablePadding: true,
        label: 'Guest and Date',
    },
    { id: 'guest_address_one', align: 'left', disablePadding: false, label: 'Guest Address One' },
    { id: 'guest_address_two', align: 'left', disablePadding: false, label: 'Guest Address Two' },
    { id: 'guest_address_one_two', align: 'left', disablePadding: false, label: 'Guest Address' },
    { id: 'guest_city', align: 'left', disablePadding: false, label: 'Guest City' },
    { id: 'guest_state', align: 'left', disablePadding: false, label: 'Guest State' },
    { id: 'guest_zip', align: 'left', disablePadding: false, label: 'Guest Zip' },
    { id: 'guest_email', align: 'left', disablePadding: false, label: 'Guest Email' },
    { id: 'guest_phone', align: 'left', disablePadding: false, label: 'Guest Phone' },
    { id: 'dates', align: 'left', disablePadding: true, label: 'Date(s)' },
    {
        id: 'user_name',
        align: 'left',
        disablePadding: true,
        label: 'Invited By (User)',
        type: 'link',
        link: '/admin/users/',
        link_id: 'invitable_id'
    },
    { id: 'group_name', align: 'left', disablePadding: true, label: 'Invited By (Group)' },
    // { id: 'title', align: 'left', disablePadding: true, label: 'Invitation Subject' },
    { id: 'details', align: 'left', disablePadding: true, label: 'Invitation Details' },
    { id: 'ticket_title', align: 'left', disablePadding: true, label: 'Ticket' },
    { id: 'variant', align: 'left', disablePadding: true, label: 'Ticket Variant' },
    {
        id: 'status',
        align: 'left',
        disablePadding: true,
        label: 'Attendence Status',
        type: 'chip',
        map: {
            'pending': 'chipPrimary',
            'accepted': 'chipSuccess',
            'maybe': 'chipDefault',
            'withdrawn': 'chipWarning',
            'declined': 'chipError',
            'entered': 'chipSecondary',
            'pay_later': 'chipWarning'
        }
    },
    { id: 'flagged', align: 'left', disablePadding: true, label: 'Flagged', type: 'bool' },
    {
        id: 'created_at',
        align: 'left',
        disablePadding: false,
        label: 'Invitation Date',
        type: 'date',
        format: 'ff'
    },
    {
        id: 'entered_at',
        align: 'left',
        disablePadding: false,
        label: 'Entered At',
        type: 'date',
        format: 'ff'
    },
];

export default function Invitations(props) {

    const {
        eventID,
        event,
        getEvent,
        tickets,
        groups
    } = props;

    return (
        <PaginatedTable
            columns={columns}
            stateKey="invitations"
            label="Invitations"
            tableUrl={`/event/${eventID}`}
            baseUrl='/admin/invitation'
            viewUrl={`/admin/events/${eventID}/invitations`}
            NewDialog={<NewInvitationDialog event={event} tickets={tickets} groups={groups} getEvent={getEvent}/>}
            FilterDialog={<InvitationFilterDialog tickets={tickets} />}
            EmailDialog={<InvitationEmailDialog event={event} />}
            PaymentDialog={<BatchPaymentDialog type="invitation" />}
        />
    );
}
